import bg7Raw from './types/bg7.svg?raw';

const PRIMARY = '#2388FF';
const ACCENT = '#4A3AFF';

function buildSvg(primary = PRIMARY, accent = ACCENT) {
  return bg7Raw
    .replace(/#2388FF/gi, primary)
    .replace(/#4A3AFF/gi, accent)
    .replace(/\s*clip-path="url\(#clip0_[^"]+\)"/g, '')
    .replace(/stroke="black"\s+stroke-opacity="[^"]+"/g, 'stroke="none"')
    .replace(/fill="black"/g, 'fill="transparent"')
    .replace(/width="\d+"/, 'width="100%"')
    .replace(/height="\d+"/, 'height="100%"')
    .replace(/<svg /, '<svg preserveAspectRatio="xMidYMid slice" ');
}

export default function GradientHeroBg({ primary = PRIMARY, accent = ACCENT }) {
  const svg = buildSvg(primary, accent);
  const dataUri = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;

  return (
    <div
      aria-hidden
      className="absolute inset-0 pointer-events-none"
      style={{
        backgroundImage: `url("${dataUri}")`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    />
  );
}
